import {
  USER_DEVICE_FINGERPRINT_HASH_SET,
  USER_DEVICE_FINGERPRINT_HASH_GET
} from "app/redux/constants/actionTypes";

const INITIAL_STATE = {
  deviceFingerprint: {
    hash: ""
  }
};

export default function user(state = INITIAL_STATE, action) {
  switch (action.type) {
    case USER_DEVICE_FINGERPRINT_HASH_SET:
      return {
        ...state,
        deviceFingerprint: {
          hash: action.value
        }
      };
    case USER_DEVICE_FINGERPRINT_HASH_GET:
      return state.deviceFingerprint && state.deviceFingerprint.hash;
    default:
      return state;
  }
}
